import React, { useEffect } from 'react'

function ContactUs() {

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);

    return (
        <div style={{ margin: 20 }}>
            <h2>Contact Us</h2>
            <p className='footer-text'>We’re here to support and connect with you! Whether you have feedback, news tips, or inquiries, please don’t hesitate to reach out:</p>
            <p className='footer-text'><strong>Phone Support:</strong></p>
            <ul>
                <li> <p className='footer-text'><strong>India:</strong> +91 94473 72726 / +91 99462 05422 / +91 94005 20909</p></li>
                <li> <p className='footer-text'><strong>USA:</strong> +1 (214) 929 7614</p></li>
                <li> <p className='footer-text'><strong>UK:</strong> +44 7951 963062</p></li>
                <li> <p className='footer-text'><strong>Australia:</strong> +61 420640472</p></li>
                <li> <p className='footer-text'><strong>Gulf:</strong> +971 50 354 0676</p></li>
            </ul>

            <p className='footer-text'><strong>Mailing Address:</strong></p>
            <ul>
                <li> <p className='footer-text'>ONLINEGOODNEWS.COM</p></li>
                <li> <p className='footer-text'>Kottayam 686 004, Kerala, India</p></li>
            </ul>

            <p className='footer-text'><strong>Office Hours:</strong></p>
            <ul>
                <li> <p className='footer-text'>Monday - Friday: 9:00 AM - 6:00 PM (IST)</p></li>
                <li> <p className='footer-text'>Closed on Saturdays, Sundays, and Public Holidays</p></li>
            </ul>

            <p className='footer-text'><strong>Email Us:</strong></p>
            <ul>
                <li> <p className='footer-text'>info@onlinegoodnews.com</p></li>
            </ul>
        </div>
    )
}

export default ContactUs;